import React from "react"

import "./Search.scss"
const Search = () => {
  return (
    <svg
      viewBox="0 0 20 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      id="search-icon"
      className="header-icon-body"
    >
      <title>Vector</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-311.000000, -28.000000)"
          className="header-icon"
        >
          <g transform="translate(311.000000, 28.000000)">
            <path d="M15.0581879,14.3684209 C16.3809568,12.8453144 17.1826338,10.8504491 17.1826338,8.66688043 C17.1959951,3.89537853 13.334579,0 8.59131692,0 C3.86141608,0 8.2067686e-14,3.89537853 8.2067686e-14,8.66688043 C8.2067686e-14,13.4383823 3.86141608,17.3337609 8.59131692,17.3337609 C10.2080345,17.3337609 11.7044999,16.8754809 13.0005462,16.0937094 L17.4765828,20.6091143 C17.7438089,20.8786907 18.0778415,21 18.4252353,21 C18.7726292,21 19.1066618,20.8652119 19.3738878,20.6091143 C19.8949786,20.0969192 19.8949786,19.2477541 19.3738878,18.7220801 L15.0581879,14.3684209 Z M8.59131692,2.69576381 C11.8514747,2.69576381 14.5103734,5.3780485 14.5103734,8.66688043 C14.5103734,11.9557124 11.8514747,14.637997 8.59131692,14.637997 C5.33115917,14.637997 2.67226039,11.9691912 2.67226039,8.66688043 C2.67226039,5.3780485 5.33115917,2.69576381 8.59131692,2.69576381 Z"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Search
